import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=70901678"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports